/**
 * Untuk membuat route baru dan panggil component yang ingin ditampilkan
 */
// import Detail from 'pages/Detail';
// import Home from 'pages/Home';
// import Article from 'pages/article/Article';
// import Project from 'pages/project/Project';
// import DetailProject from 'pages/project/DetailProject';
// import DetailArticle from 'pages/article/DetailArticle';
// import Tutorial from 'pages/tutorial/Tutorial';
// import DetailTutorial from 'pages/tutorial/DetailTutorial';
// import ListTutorial from 'pages/tutorial/ListTutorial';
// import DummyList from 'pages/tutorial/DummyList';

import Detail from '../pages/Detail';
import Home from '../pages/Home';
import Article from '../pages/article/Article';
import Project from '../pages/project/Project';
import DetailProject from '../pages/project/DetailProject';
import DetailArticle from '../pages/article/DetailArticle';
import Tutorial from '../pages/tutorial/Tutorial';
import DetailTutorial from '../pages/tutorial/DetailTutorial';
import ListTutorial from '../pages/tutorial/ListTutorial';
import DummyList from '../pages/tutorial/DummyList';

const routes = [
    { path: '/', exact: true, name: 'Home', component: Home },
    { path: '/home', exact: true, name: 'Article', component: Home },
    { path: '/detail', exact: true, name: 'Detail', component: Detail },
    
    { path: '/article', exact: true, name: 'Article', component: Article },
    { path: '/article/read/:slug', exact: true, name: 'Read Article', component: DetailArticle },

    { path: '/tutorial', exact: true, name: 'Category Tutorial', component: Tutorial },
    { path: '/tutorial/:slug', exact: true, name: 'List Category Tutorial', component: ListTutorial },
    { path: '/tutorial/read/:slug', exact: true, name: 'Detail Tutorial', component: DetailTutorial },
    
    { path: '/project', exact: true, name: 'Project', component: Project },
    { path: '/project/detail/:slug', exact: true, name: 'Project Detail', component: DetailProject }
];

export default routes